angular.module('zc.core')
  .factory('lineChartV2Config', lineChartV2Config);

lineChartV2Config.$inject = ['chronologicalChartV2Config'];
function lineChartV2Config(chronologicalChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'line' },
    }
  }, chronologicalChartV2Config);
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/line_chart_v2_config.service.js